export default {
  login: 'simoncheam',
  id: 81940817,
  node_id: 'MDQ6VXNlcjgxOTQwODE3',
  avatar_url: 'https://avatars.githubusercontent.com/u/81940817?v=4',
  gravatar_id: '',
  url: 'https://api.github.com/users/simoncheam',
  html_url: 'https://github.com/simoncheam',
  followers_url: 'https://api.github.com/users/simoncheam/followers',
  following_url: 'https://api.github.com/users/simoncheam/following{/other_user}',
  gists_url: 'https://api.github.com/users/simoncheam/gists{/gist_id}',
  starred_url: 'https://api.github.com/users/simoncheam/starred{/owner}{/repo}',
  subscriptions_url: 'https://api.github.com/users/simoncheam/subscriptions',
  organizations_url: 'https://api.github.com/users/simoncheam/orgs',
  repos_url: 'https://api.github.com/users/simoncheam/repos',
  events_url: 'https://api.github.com/users/simoncheam/events{/privacy}',
  received_events_url: 'https://api.github.com/users/simoncheam/received_events',
  type: 'User',
  site_admin: false,
  name: 'Simon',
  company: null,
  blog: '',
  location: null,
  email: null,
  hireable: null,
  bio: null,
  twitter_username: null,
  public_repos: 61,
  public_gists: 1,
  followers: 2,
  following: 4,
  created_at: '2021-04-05T01:53:45Z',
  updated_at: '2022-03-13T18:28:01Z',
};
